<template>
  <div>
    <form
      autocomplete="off"
      name="page-form"
      @submit.prevent="createProductoPaginaIdroop"
    >
    <div
      key="modal section"
      class="m-container-primary"
    >
      <div class="row">
        <div class="column column-8">
          <blockquote class="quote quote-products-primary quote-first">
            <p>
            {{ $t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.quote') }}
            </p>
          </blockquote>
          <AtomInputPrimary
            v-model="pagina.nombre"
            :inputError="$v.pagina.nombre.$error"
            :label="$t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.inputs.nombre.label')"
            :message="$t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.inputs.nombre.message')"
            :messageError="messageErrorNombre"
            name="nombre"
            :placeholder="$t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.inputs.nombre.placeholder')"
            type="text"
            @blur="$v.pagina.nombre.$touch()"
          />
          <AtomInputPrimary
            v-model="pagina.url"
            :inputError="$v.pagina.url.$error"
            :label="$t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.inputs.url.label')"
            :messageError="messageErrorUrl"
            name="url"
            :placeholder="$t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.inputs.url.placeholder')"
            type="text"
            @blur="$v.pagina.url.$touch()"
          />
          <AtomButtonPrimary :button-primary="buttonPrimary"/>
        </div>
      </div>
      </div>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required, url } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionProductPagesOfGratefulnessCreateExternalSite',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.buttonPrimary'),
        class: 'a-button-products-primary',
        sending: false,
        type: 'submit'
      },

      pagina: {
        externo: 1,
        nombre: '',
        producto: this.$route.params.id,
        tipo: 1,
        url: ''
      }
    }
  },

  validations: {
    pagina: {
      nombre: {
        maxLength: maxLength(60),
        minLength: minLength(1),
        required
      },

      url: {
        required,
        url
      }
    }
  },

  computed: {
    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionProductPagesOfGratefulnessModalCreateExternalSite', this.$v.pagina.nombre, 'nombre')
    },

    messageErrorUrl () {
      return this.$validation.getValidationMessage('mEditionProductPagesOfGratefulnessModalCreateExternalSite', this.$v.pagina.url, 'url')
    }
  },

  methods: {
    createProductoPaginaIdroop () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('producto', 'createProductoPaginaIdroop', this.pagina)
          .then(response => {
            this.$modal.updateData()
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionProductPagesOfGratefulnessModalCreateExternalSite', 'createProductoPaginaIdroop', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductPagesOfGratefulnessModalCreateExternalSite', 'createProductoPaginaIdroop', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
